// extracted by mini-css-extract-plugin
export default {"Canvas":"Canvas_Canvas__CrLpV","gradient":"Canvas_gradient__EhZAb","CanvasFallback":"Canvas_CanvasFallback__qUnQt"};